import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">精选好剧推荐</h2>
        <p className="section-subtitle">每日精选高分剧集，覆盖古装、都市、悬疑、韩剧等热门类型</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardsData.slice(0, 6).map((card) => (
            <article
              key={card.title}
              className="group bg-background-100 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4">
                <h3 className="text-base font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.description}
                </p>
              </div>
            </article>
          ))}

          <article className="group bg-gradient-to-br from-primary-500 to-primary-700 rounded-lg overflow-hidden cursor-pointer flex flex-col items-center justify-center p-8 text-center min-h-[200px]">
            <div className="w-14 h-14 rounded-full bg-background-50/20 flex items-center justify-center mb-4">
              <i className="ri-arrow-right-line text-2xl text-background-50"></i>
            </div>
            <h3 className="text-lg font-heading text-background-50">查看更多精选</h3>
            <p className="mt-2 text-sm text-background-50/80">发现更多高分好剧</p>
          </article>
        </div>
      </div>
    </section>
  );
}